import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {ExgModalService, ExgPopupComponent} from 'exc-controls-v2';
import {ExgApplicationTab} from 'exc-tab-v2';
import {ExcSecurityService} from 'exc-security-v2';
import {Questionnaire} from './Interfaces/Questionnaire.interface';
import {TableCol} from './Interfaces/TableCol.interface';
import {TableRow} from './Interfaces/TableRow.interface';
import ToolboxDataStore from './ToolboxDataStore';
import {ObjectList} from './Interfaces/ObjectList.interface';
import {QuestionnaireRendererComponent} from '../questionnaire-renderer/questionnaire-renderer.component';
import {CdkDragDrop, CdkDragMove, CdkDragStart, copyArrayItem, moveItemInArray} from '@angular/cdk/drag-drop';


@Component({
  selector: 'app-questionnaire-editor',
  templateUrl: './questionnaire-editor.component.html',
  styles: []
})
export class QuestionnaireEditorComponent extends ExcTranslation implements OnInit {
  @ViewChild('popupTask', {read: ExgPopupComponent}) menu: ExgPopupComponent | undefined;
  @ViewChild('selectInput') selectInput!: ElementRef;
  @ViewChild('image', {read: ExgPopupComponent}) imageContainer: ExgPopupComponent | undefined;
  @ViewChild('toolTip', {read: ExgPopupComponent}) toolTipContainer: ExgPopupComponent | undefined;

  qcnfID = '666';
  availableConfigs: any[] = [] as any[];
  currentConfig: any = {} as any;

  @Input()
  Data: { qcnfID: string; } = {
    qcnfID: ''
  };

  selectedData: any;
  isMove = false;
  questionnaire: Questionnaire[] = [];
  freeQuestions: Questionnaire[] = [];
  segments: any[] = [];
  kids: any[] = [];
  clients: any[] = [];
  deleted: any[] = [];
  kidList: any[] = [];
  selectedOption: any = {};
  selectedQuest: Questionnaire | undefined;
  /*selectedQuest: Questionnaire = {
    quest_enmIdent_questType: 0,
    counter: 0,
    quest_Ident: 0,
    questIdentation: 0,
    quest_enmIdent_questValueFormat: 0,
    name: '',
    questText: '',
    questHelp: '',
    questIsOptional: false,
    questScore: 0,
    questFollowUp: '',
    questFollowUpDays: 0,
    questFollowUpFixD: undefined,
    quest_kidID: '',
    quest_segID: '',
    questFollowUpShortText: '',
    questCondition: '',
    questCondition_questID: '',
    questConditional: false,
    questParentkey: '',
    questID: '',
    questKey: '',
    icon: '',
    tooltip: '',
    questIsKO: false,
    questIsInapplicable: false,
    followUpType: 0,
    questPreText: '',
    questConfiguration: '',
    questLink: '',
    configs: undefined,
    FileStream: '',
    MIME: '',
    questLinkText: '',
    valid: false,
    questHexCode: '',
  };*/
  selectedToolbox: any = {};
  toolbox: any[] = [];
  isChange = false;
  followupIsActive = false;
  conditionalIsActive = false;
  tableDetailsIsActive = false;
  detailsIsActive = false;
  excRestServiceCore = ExcCoreModule.Services().ExcRest;
  hiddenItems: any = [];
  collapsed: any = [];
  closed = false;
  isKidListVisible = false;
  questionnaireIndex = 0;
  searchQuery = '';
  lastpos: any;
  isUpMove = false;
  _selectedIdentIndex: any;
  isLocked = false;
  isMultipleSelect = false;
  uiOptions: any = {
    Current: 0, Values: [
      {Group: 1, Name: this.getRessource('FollowUpDays')},
      {Group: 2, Name: this.getRessource('FollowUpDate')}]
  };
  selectedItems: Questionnaire[] = [];
  selectedRowIndex: number | undefined = undefined;
  selectedColIndex: number | undefined = undefined;
  selectedRow: TableRow | undefined;
  selectedCol: TableCol | undefined;
  selectedScore: number | undefined = undefined;
  selectedTooltip = '';
  ComponentUID = ExcCoreModule.Guid.NewGuid();
  rerender: any = {};

  constructor(private modalService: ExgModalService, public excSecurityService: ExcSecurityService, private toolboxData: ToolboxDataStore) {
    super();
    this.onLangChange().subscribe(() => {
      this.toolbox = toolboxData.getToolBoxData();
    });
  }

  _selectedQuestionnaireIndex: any;

  get selectedQuestionnaireIndex(): number {
    return this._selectedQuestionnaireIndex;
  }

  set selectedQuestionnaireIndex(value: number) {
    this._selectedQuestionnaireIndex = value;
    this.setSelectedData();
  }

  static convertToPaddedString(input: string): string {
    const parts = input.split('.');
    const paddedParts = parts.map(part => {
      const paddedValue = part.padStart(4, '0');
      return paddedValue.substring(paddedValue.length - 4);
    });
    const re = /,/gi;
    return paddedParts.toString().replace(re, '.') + '.';
  }

  static getParentNode(node: string): string {
    node = node.substr(0, node.lastIndexOf('.'));
    const lastDotIndex = node.lastIndexOf('.');
    return node.slice(0, lastDotIndex + 1);
  }

  private static setScrollOnIcon(): void {
    if (document.getElementById('selected-li') !== null) {
      document.getElementById('selected-li')?.scrollIntoView();
    }
  }

  ngOnInit(): void {
    if (this.Data.qcnfID) {
      this.qcnfID = this.Data.qcnfID;
    }

    this.toolbox = this.toolboxData.getToolBoxData();
    this.getInitData();
    this.isChange = false;
  }

  /** Data Calls */
  getInitData(): void {
    const _self = this;

    const cfgListUrl = _self.excRestServiceCore.computeUrl('QuestionnaireConfigR_List', {qcnfID: _self.qcnfID});
    _self.excRestServiceCore.sget(cfgListUrl, ExcCoreModule.Guid.NewGuid(), {}).subscribe((ret: any) => {
      _self.availableConfigs = ret.data.QuestionnaireConfig;
      _self.currentConfig = _self.availableConfigs.filter(e => {
        return e.qcnfID === parseInt(_self.qcnfID, undefined);
      })[0];
      console.log(_self.availableConfigs, _self.currentConfig);
    });

    this.initQuestionnaire();

  }

  initQuestionnaire(): void {
    const _self = this;
    const url = _self.excRestServiceCore.computeUrl('QuestionnaireR_List_Editor', {qcnfID: _self.qcnfID});
    _self.excRestServiceCore.sget(url, ExcCoreModule.Guid.NewGuid(), {}).subscribe((ret: any) => {
      if (ret.success && ret.data) {
        _self.questionnaire = ret.data.Questionnaire;
        _self.segments = ret.data.Segments;
        _self.clients = ret.data.Clients;
        _self.kids = ret.data.Kids;
        if (ret.data.ResultState.ResultCount !== undefined) {
          if (ret.data.ResultState.ResultCount > 0) {
            _self.isLocked = true;
          }
        }
        this.kidList = Object.assign([], this.kids);
        if (_self.questionnaire.length > 0) {
          this.setSelectedData(0);
          _self.questionnaire.forEach(x => {
            if (x.questConfiguration?.length > 0 && [17, 19].includes(x.quest_enmIdent_questValueFormat)) {
              x.configs = this.getArray(x.questConfiguration);
            }
          });
        }
      }
    });
  }

  exportQuestionnaire(): void {
    const url = this.excRestServiceCore.computeUrl('QuestionnaireEditorR_Report', {qcnfID: this.qcnfID});
    this.excRestServiceCore.sget(url, ExcCoreModule.Guid.NewGuid(), {export: true}).subscribe((ret: any) => {
    });
  }

  /** Drag and Drop Control */
  findIndex(event: CdkDragDrop<string[]>): { curIndex: number; preIndex: number | undefined; } {
    let newQuestionnaire: Questionnaire[] = [];
    let currentIndex;
    let previousIndex;
    // MOVE
    if (event.previousContainer.id === event.container.id) {
      if (this.hiddenItems.length !== 0) {
        newQuestionnaire = this.questionnaire.filter(x => !this.hiddenItems.includes(x.questID));
        if (newQuestionnaire[event.currentIndex]) { // && newQuestionnair.length - 1 !== event.currentIndex
          if (event.currentIndex > event.previousIndex) {
            if (this.collapsed.indexOf(newQuestionnaire[event.currentIndex].questID) !== 1) {
              currentIndex = this.questionnaire.findIndex(x => x.questID === newQuestionnaire[event.currentIndex].questID) +
                this.getChildren(newQuestionnaire[event.currentIndex]).length;
            } else {
              currentIndex = this.questionnaire.findIndex(x => x.questID === newQuestionnaire[event.currentIndex].questID);
            }
          } else {
            currentIndex = this.questionnaire.findIndex(x => x.questID === newQuestionnaire[event.currentIndex].questID);
          }
          event.currentIndex = currentIndex;
        }
      } else {
        newQuestionnaire = this.questionnaire;
      }
      previousIndex = this.questionnaire.findIndex(x => x.questID === newQuestionnaire[event.previousIndex].questID);
    } else {
      // COPY
      if (this.hiddenItems.length !== 0) {
        newQuestionnaire = this.questionnaire.filter(x => !this.hiddenItems.includes(x.questID));
        if (newQuestionnaire[event.currentIndex]) { // && newQuestionnair.length - 1 !== event.currentIndex
          currentIndex = this.questionnaire.findIndex(x => x.questID === newQuestionnaire[event.currentIndex].questID);
          event.currentIndex = currentIndex;
        } else {
          event.currentIndex = this.questionnaire.length;
        }
      }
    }
    return {curIndex: event.currentIndex, preIndex: previousIndex};
  }

  castDrop(value: any | any[]): CdkDragDrop<string[]> {
    return value as unknown as CdkDragDrop<string[]>;
  }

  drop(event: CdkDragDrop<string[]>): void {
    const obj: { curIndex: number, preIndex: number | undefined } = this.findIndex(event);
    let newQuestionnaire: Questionnaire[] = [];
    if (this.hiddenItems.length !== 0) {
      newQuestionnaire = this.questionnaire.filter(x => !this.hiddenItems.includes(x.questID));
    } else {
      newQuestionnaire = this.questionnaire;
    }
    event.currentIndex = obj.curIndex;
    if (event.previousContainer.id === event.container.id) {
      // MOVE
      if (event.currentIndex !== event.previousIndex && !this.isMultipleSelect) {
        /* Move Option in questionnaire */
        if (newQuestionnaire[event.previousIndex].quest_enmIdent_questType === 3) {
          if (obj.preIndex) {
            event.previousIndex = obj.preIndex;
          }
          if (this.isParentSelectOption(this.questionnaire[event.currentIndex].quest_enmIdent_questValueFormat) &&
            this.isParentSelectOption(this.questionnaire[event.currentIndex - 1].quest_enmIdent_questValueFormat) &&
            this.questionnaire[event.currentIndex].quest_enmIdent_questValueFormat !== 1 &&
            this.questionnaire[event.currentIndex - 1].quest_enmIdent_questValueFormat !== 1 &&
            this.questionnaire[event.previousIndex].quest_enmIdent_questValueFormat !== 1
          ) {
            this.moveDragDropItem(event);
          }
          /* Move Chapter in questionnaire */
        } else if (newQuestionnaire[event.previousIndex].quest_enmIdent_questType === 1) {
          if (obj.preIndex) {
            event.previousIndex = obj.preIndex;
          }
          if ((event.currentIndex === 0 || event.currentIndex === newQuestionnaire.length - 1) ||
            (!this.isBetweenOptions(event.currentIndex) && !this.isBetweenQuestionAndOption(event.currentIndex))) {
            if (this.hasChild(this.questionnaire[event.previousIndex])) {
              this.moveChildren(event);
            } else {
              this.moveDragDropItem(event);
            }
          }
        }
        /* Move Sub-Chapter and Question in questionnaire */
        else {
          if (obj.preIndex) {
            event.previousIndex = obj.preIndex;
          }
          let manipulatedCurIndex: number;
          if (event.currentIndex < event.previousIndex) {
            manipulatedCurIndex = event.currentIndex - 1;
          } else {
            manipulatedCurIndex = event.currentIndex;
          }
          if ((event.currentIndex !== 0
            && (!this.isBetweenOptions(manipulatedCurIndex)) &&
            !this.isBetweenQuestionAndOption(manipulatedCurIndex)) || event.currentIndex === this.questionnaire.length - 1) {
            if (this.hasChild(this.questionnaire[event.previousIndex])) {
              this.moveChildren(event);
            } else {
              this.moveDragDropItem(event);
            }
          }
        }
      } else if (event.currentIndex !== event.previousIndex && this.isMultipleSelect) {
        // Move multiple select items
        if (obj.preIndex) {
          event.previousIndex = obj.preIndex;
        }
        if ((event.currentIndex !== 0
          && (!this.isBetweenOptions(event.currentIndex)) &&
          !this.isBetweenQuestionAndOption(event.currentIndex)) || event.currentIndex === this.questionnaire.length - 1) {
          let removedItems: Questionnaire[] = [];
          for (const item of this.selectedItems) {
            removedItems.push(item);
            if (this.hasChild(item)) {
              removedItems = removedItems.concat(this.getChildren(item));
            }
          }
          // Remove Items
          this.questionnaire = this.questionnaire.filter((item) =>
            removedItems.findIndex(x => x.questID === item.questID) === -1
          );
          this.questionnaire.splice(obj.curIndex, 0, ...removedItems);
        }
        this.selectedItems = [];
        this.isMultipleSelect = false;
      }
      this.isChange = true;
    } else { // COPY
      if (this.toolbox[event.previousIndex].quest_enmIdent_questType === 3) {
        if (this.isParentSelectOption(this.questionnaire[event.currentIndex - 1].quest_enmIdent_questValueFormat)) {
          this.copyDragDropItem(event);
          this.questionnaire[event.currentIndex].quest_enmIdent_questValueFormat =
            this.questionnaire[event.currentIndex - 1].quest_enmIdent_questValueFormat;
        }
      } else if ([1, 2, 3].includes(this.toolbox[event.previousIndex].quest_enmIdent_questValueFormat) &&
        this.toolbox[event.previousIndex].quest_enmIdent_questType === 2) {
        if (event.container.data.length !== 0 && event.currentIndex !== 0) {
          if (!this.questionnaire[event.currentIndex] || this.questionnaire[event.currentIndex].quest_enmIdent_questType !== 3) {
            this.copyDragDropItem(event);
            this.addOption(event);
          }
        }
      } else {
        if (event.container.data.length === 0 || event.currentIndex === 0) {
          if (this.toolbox[event.previousIndex].quest_enmIdent_questType === 1) {
            this.copyDragDropItem(event);
          }
        } else {
          if (!event.container.data[event.currentIndex]) {
            this.copyDragDropItem(event);
          } else {
            if (this.questionnaire[event.currentIndex - 1] !== undefined && this.questionnaire[event.currentIndex] !== undefined &&
              (!this.isBetweenOptions(event.currentIndex - 1) &&
                !this.isBetweenQuestionAndOption(event.currentIndex - 1))) {
              this.copyDragDropItem(event);
            }
          }
        }
      }
      this.isChange = true;
    }
    this.isMove = false;
    this.setIdentation(this.questionnaire);
  }

  moveDragDropItem(event: any): void {
    if (this.questionnaire[event.previousIndex].quest_enmIdent_questType === 3) {
      this.questionnaire[event.previousIndex].quest_enmIdent_questValueFormat =
        this.questionnaire[event.currentIndex].quest_enmIdent_questValueFormat;
    }
    moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    this.isChange = true;
  }

  copyDragDropItem(event: any): void {
    copyArrayItem(JSON.parse(JSON.stringify(event.previousContainer.data)),
      event.container.data, event.previousIndex, event.currentIndex);
    if (this.questionnaire[event.currentIndex].questID === null) {
      this.questionnaire[event.currentIndex].questID = ExcCoreModule.Guid.NewGuid();
    }
    this.isChange = true;
    if (this.questionnaire.length === 1) {
      this.setSelectedData(0);
    }
  }

  moveChildren(obj: CdkDragDrop<string[]>): void {
    if (this.isChapter(obj) || this.isQuestion(obj) && obj.currentIndex !== 0) {
      const result = this.getChildren(this.questionnaire[obj.previousIndex]);
      if (obj.currentIndex > obj.previousIndex) {
        const result1: Questionnaire[] = this.getChildren(this.questionnaire[obj.currentIndex]);
        obj.currentIndex = obj.currentIndex + result1.length;
        moveItemInArray(this.questionnaire, obj.previousIndex, obj.currentIndex);
        const id = this.questionnaire[obj.currentIndex].questID;
        this.questionnaire = this.questionnaire.filter(a => !result.map(b => b.questID).includes(a.questID));
        this.questionnaire = this.insertArrayAtIndex(this.questionnaire, result, this.questionnaire.findIndex(x => x.questID === id) + 1);
      } else {
        moveItemInArray(this.questionnaire, obj.previousIndex, obj.currentIndex);
        this.questionnaire = this.questionnaire.filter(a => !result.map(b => b.questID).includes(a.questID));
        this.questionnaire = this.insertArrayAtIndex(this.questionnaire, result, obj.currentIndex + 1);
      }
    }
  }

  onDragMoved(event: CdkDragMove): void {
    const pointerPosition = event.pointerPosition;
    if (this.lastpos) {
      this.isUpMove = this.lastpos.y > pointerPosition.y;
    }
    this.lastpos = pointerPosition;
  }

  onDragStarted(event: CdkDragStart<any>, index: number): void {
    const draggedItem = event; // Store the dragged item
    this.selectedToolbox.index = index;
    this.selectedToolbox.data = draggedItem;
  }

  castDrag(value: any | any[]): CdkDragStart<any> {
    return value as unknown as CdkDragStart<any>;
  }

  onQuestionnaireDragStarted(event: CdkDragStart<any>): void {
    this.isMove = true;
  }

  /** Questionnaire Data Manipulation */
  deleteElement(): void {
    let message = '';
    let hasChild = false;
    if (this.isMultipleSelect) {
      // DELETE Multiple Items
      this.modalService.showSimple(
        this.getGlobal('DeleteHeader')
        , this.getRessource('ElementDeleteModalMessage')
        , true, true
        , this.getGlobal('DeleteHeader'), this.getGlobal('Cancel')
      ).subscribe(wantsToDelete => {
        if (wantsToDelete) {
          let removedItems: Questionnaire[] = [];
          for (const item of this.selectedItems) {
            removedItems.push(item);
            if (this.hasChild(item)) {
              removedItems = removedItems.concat(this.getChildren(item));
            }
          }
          // Remove Items
          this.questionnaire = this.questionnaire.filter((item) =>
            removedItems.findIndex(x => x.questID === item.questID) === -1
          );
          this.isChange = true;
          this.setIdentation(this.questionnaire);
          this.setSelectedData(0);
          this.selectedItems = [];
          this.isMultipleSelect = false;
        } else {
          this.selectedItems = [];
          this.isMultipleSelect = false;
        }
      });
    } else {
      if (this.isDeleteAllowed()) {
        if (this.hasChild(this.selectedQuest)) {
          message = this.getRessource('ElementDeleteWithChildModalMessage');
          hasChild = true;
        } else {
          message = this.getRessource('ElementDeleteModalMessage');
        }
        this.modalService.showSimple(
          this.getGlobal('DeleteHeader')
          , message
          , true, true
          , this.getGlobal('DeleteHeader'), this.getGlobal('Cancel')
        ).subscribe(wantsToDelete => {
          if (wantsToDelete) {
            if (hasChild) {
              const result: Questionnaire[] = this.getChildren(this.selectedQuest as Questionnaire);
              // delete option of question
              result.forEach((x) => {
                this.questionnaire.forEach((quest) => {
                  if (x.questID === quest.questCondition) {
                    this.removeCondition(quest);
                  }
                });
              });
              const isSameElement = (a: any, b: any) => a.questID === b.questID;
              const onlyInLeft = (left: any, right: any, compareFunction: any) =>
                left.filter((leftValue: any) =>
                  !right.some((rightValue: any) =>
                    compareFunction(leftValue, rightValue)));

              this.questionnaire = onlyInLeft(this.questionnaire, result, isSameElement);
              this.questionnaire = this.questionnaire.filter(x => x.questID !== this.selectedQuest?.questID);
            } else {
              this.questionnaire = this.questionnaire.filter(x => x.questID !== this.selectedQuest?.questID);
            }
            this.selectedData = undefined;
            this.deleted = [];
            this.isChange = true;
            this.setIdentation(this.questionnaire);
            this.setSelectedData(0);
          }
        });
      }
    }
  }

  setSelectedData(index?: number): void {
    if (index || index === 0) {
      this.selectedQuest = this.questionnaire[index];
    } else {
      this.selectedQuest = this.questionnaire[this.selectedQuestionnaireIndex];
    }
    this.getFreeQuestionList();
    if (this.selectedQuest && this.kids && this.selectedQuest.quest_kidID && this.hasKPI(this.selectedQuest)) {
      this.kids.forEach((x: any) => {
        if (x.kidID === this.selectedQuest?.quest_kidID) {
          this.selectedOption = x;
          this.searchQuery = x.kidName;
        }
      });
    } else {
      this.selectedOption = null;
      this.searchQuery = '';
      this.kids = this.kidList;
    }
    if (this.selectedQuest?.quest_enmIdent_questType === 3) {
      if (this.selectedQuest.questFollowUpDays === null) {
        if (this.selectedQuest.questFollowUpFixD === null) {
          this.selectedQuest.followUpType = 0;
        } else {
          this.selectedQuest.followUpType = 1;
        }
      } else {
        this.selectedQuest.followUpType = 0;
      }
    }
    if (this.selectedQuest.quest_enmIdent_questType === 2 && this.selectedQuest.quest_enmIdent_questValueFormat === 17) {
      // selectedArray  = JSON.parse(this.selectedQuest.questConfiguration);
    }
  }

  addOption(event: CdkDragDrop<string[]>): void {
    const valueType = this.questionnaire[event.currentIndex].quest_enmIdent_questValueFormat;
    const index = this.toolbox.findIndex(x => x.quest_enmIdent_questType === 3);
    if (this.questionnaire[event.currentIndex].quest_enmIdent_questValueFormat === 1) {
      copyArrayItem(JSON.parse(JSON.stringify(event.previousContainer.data)),
        event.container.data, index, event.currentIndex + 1);
      this.questionnaire[event.currentIndex + 1].questText = this.getGlobal('Yes');
      this.questionnaire[event.currentIndex + 1].questID = ExcCoreModule.Guid.NewGuid();
      this.questionnaire[event.currentIndex + 1].quest_enmIdent_questValueFormat = 1;
      copyArrayItem(JSON.parse(JSON.stringify(event.previousContainer.data)),
        event.container.data, index, event.currentIndex + 2);
      this.questionnaire[event.currentIndex + 2].questText = this.getGlobal('No');
      this.questionnaire[event.currentIndex + 2].questID = ExcCoreModule.Guid.NewGuid();
      this.questionnaire[event.currentIndex + 2].quest_enmIdent_questValueFormat = 1;
    } else {
      copyArrayItem(JSON.parse(JSON.stringify(event.previousContainer.data)),
        event.container.data, index, event.currentIndex + 1);
      this.questionnaire[event.currentIndex + 1].name = 'Option';
      this.questionnaire[event.currentIndex + 1].questID = ExcCoreModule.Guid.NewGuid();
      this.questionnaire[event.currentIndex + 1].quest_enmIdent_questValueFormat = valueType;
      copyArrayItem(JSON.parse(JSON.stringify(event.previousContainer.data)),
        event.container.data, index, event.currentIndex + 2);
      this.questionnaire[event.currentIndex + 2].questText = '';
      this.questionnaire[event.currentIndex + 2].name = 'Option';
      this.questionnaire[event.currentIndex + 2].questID = ExcCoreModule.Guid.NewGuid();
      this.questionnaire[event.currentIndex + 2].quest_enmIdent_questValueFormat = valueType;
    }
  }

  /** Questionnaire Element Identification */
  setIdentation(array: any): void {
    let i = 0;
    array.forEach((value: any, index: any) => {
      if (this.questionnaire[index].quest_enmIdent_questType === 1 && this.questionnaire[index].questIdentation > 0) {
        this.questionnaire[index].quest_enmIdent_questType = -1;
      }
      if (this.questionnaire[index].quest_enmIdent_questType === -1 && this.questionnaire[index].questIdentation < 1) {
        this.questionnaire[index].quest_enmIdent_questType = 1;
        this.questionnaire[index].questIdentation = 0;
      }
      if (value.quest_enmIdent_questType === 1) {
        i++;
        value.quest_Ident = i;
        value.questKey = QuestionnaireEditorComponent.convertToPaddedString(i.toString());
        value.questParentkey = '';
        value.counter = 0;
        value.questIdentation = 0;
      }
      if ([-1, 2, 3].includes(value.quest_enmIdent_questType)) {
        if (value.quest_enmIdent_questType === -1 || ([1, 2, 3].includes(value.quest_enmIdent_questValueFormat)
          && value.quest_enmIdent_questType === 2)) {
          value.counter = 0;
        }
        if (i === 0) {
          value.quest_Ident = '';
        } else {
          const obj: any = this.getChapter(index);
          value.quest_Ident = obj;
          value.questKey = QuestionnaireEditorComponent.convertToPaddedString(obj).replace(',', '.');
          value.questParentkey =
            QuestionnaireEditorComponent.getParentNode(QuestionnaireEditorComponent.convertToPaddedString(obj));
          if (![-1, 1].includes(this.questionnaire[index].quest_enmIdent_questType)) {
            value.questIdentation = obj.split('.').length - 1;
          }
        }
      }
    });
  }

  onItemSelect(index: number): void {
    if (this.freeQuestions[index].quest_enmIdent_questType === 2 && !this.getChapterNode(this.freeQuestions[index])?.questConditional) {
      if (this.selectedQuest?.questID === this.freeQuestions[index].questCondition) {
        this.removeCondition(this.freeQuestions[index]);
      } else {
        // this.setConditionalQuestion(index, this.selectedQuest);
        if (this.selectedQuest) {
          this.freeQuestions[index].questCondition = this.selectedQuest.questID;
          this.freeQuestions[index].questCondition_questID = this.getParentQuest(this.selectedQuest.questParentkey);
        }
        this.freeQuestions[index].questConditional = true;
      }
    } else if ([1, -1].includes(this.freeQuestions[index].quest_enmIdent_questType)) {
      this.setChapterConditional(this.freeQuestions[index], (this.selectedQuest?.questID === this.freeQuestions[index].questCondition));
    }
    this.getFreeQuestionList();
    this.isChange = true;
  }

  setChapterConditional(chapter: any, remove: any): void {
    if (chapter) {
      let completeChapterData: any;
      if (chapter.quest_enmIdent_questType === 1) {
        completeChapterData = this.freeQuestions.filter(x => x.questKey.substring(0, 4) === chapter.questKey.substring(0, 4));
      } else {
        completeChapterData = this.freeQuestions.filter(x => x.questKey.substring(0, 9) === chapter.questKey.substring(0, 9));
      }
      // tslint:disable-next-line:prefer-const
      for (let element of completeChapterData) {
        if (remove) {
          this.removeCondition(element);
        } else {
          element.questCondition = this.selectedQuest?.questID;
          if (this.selectedQuest) {
            element.questCondition_questID = this.getParentQuest(this.selectedQuest.questParentkey);
          }
          element.questConditional = true;
        }
      }
    }
  }

  setIndex(event: any, i: number, item: any): void {
    if (i !== 0) {
      if (item === 'd') {
        this.questionnaireIndex = i;
      } else {
        if (!this.isUpMove) {
          this.questionnaireIndex++;
        }
      }
    } else {
      this.questionnaireIndex = 0;
    }
  }

  /** Questionnaire Main Functions */
  showCopyModal(): void {
    const _self = this;
    if (!_self.isMultipleSelect) {
      _self.modalService.show('ModalCopyQuestionnaireChapterComponent',
        {clients: _self.clients, qcnfID: this.qcnfID}).subscribe(chapter => {
        if (chapter) {
          const questionnaireObject = this.validateQuestID(chapter);
          this.questionnaire = this.questionnaire.concat(questionnaireObject);
          this.setIdentation(this.questionnaire);
          this.isChange = true;
          this.setSelectedData(0);
        }
      });
    }
  }

  saveQuestionnaire(): void {
    const _self = this;
    _self.questionnaire.forEach(item => {
      if (item.questFollowUpFixD) {
        item.questFollowUpFixD = new Date(item.questFollowUpFixD);
      }
      if (!item.questIsKO) {
        item.questIsKO = false;
      }
    });
    const url = _self.excRestServiceCore.computeUrl('QuestionnaireC_List', {qcnfID: this.qcnfID});
    _self.excRestServiceCore.post(url, {QuestionnaireList: _self.questionnaire}).subscribe(() => {
      this.isChange = false;
      this.showCheckToast('Speichern erfolgreich!');
    });
  }

  openEditMenu(obj: Questionnaire, type: any, i?: number): void {
    if (type === 'kid') {
      this.modalService.showSimple(
        'Kid Information'
        , this.kids.find(x => x.kidID === obj.quest_kidID).kidName
        , false, true
        , this.getGlobal('OK'), this.getGlobal('Close')
      ).subscribe(() => {
      });
    } else if (type === 'help') {
      this.modalService.showSimple(
        'Hilfetext'
        , obj.questHelp
        , false, true
        , this.getGlobal('OK'), this.getGlobal('Close')
      ).subscribe(() => {
      });
    } else if (type === 'seg') {
      this.modalService.showSimple(
        'Segment'
        , this.segments[this.segments.findIndex(x => x.segID === obj.quest_segID)].segName
        , false, true
        , this.getGlobal('OK'), this.getGlobal('Close')
      ).subscribe(() => {
      });
    } else if (type === 'followup') {
      this.modalService.showSimple(
        this.getRessource('LabelFollowUpSText')
        , obj.questFollowUpShortText
        , false, true
        , this.getGlobal('OK'), this.getGlobal('Close')
      ).subscribe(() => {
      });
    } else if (type === 'conditional') {
      let text = '';
      if (obj.quest_enmIdent_questType === 1) {
        text = 'LabelChapterConditional';
      } else if (obj.quest_enmIdent_questType === -1) {
        text = 'LabelSChapterConditional';
      } else if (obj.quest_enmIdent_questType === 2) {
        text = 'LabelConditional';
      }
      this.modalService.showSimple(
        'Info zur Bedingung'
        , this.getRessource(text,
          {
            optionText: this.questionnaire.find(x => x.questID === obj.questCondition)?.questText,
            QuestionIdent: this.questionnaire.find(x => x.questID === obj.questCondition_questID)?.quest_Ident
          })
        , false, true
        , this.getGlobal('OK'), this.getGlobal('Close')
      ).subscribe(() => {
      });
    } else if (type === 'hasCondition' && i) {
      if (this.selectedQuest?.questID !== this.questionnaire[i].questID) {
        this.setSelectedData(i);
      }
      let str = '';
      let list = '';
      this.getConditionalElementList(obj).forEach((x, index) => {
        if (index === 0) {
          list = x.quest_Ident.toString();
        } else {
          list = list + ' ,' + +x.quest_Ident;
        }
      });
      if (this.getConditionalElementList(obj)?.length > 1) {
        str = this.getResource('OptionConditions', {cn: this.getConditionalElementList(obj)?.length}) + ' /n   ' + list;
      } else {
        str = this.getResource('OptionCondition',
          {ident: this.getConditionalElementList(this.selectedQuest as Questionnaire)[0]?.quest_Ident});
      }
      this.modalService.showSimple(
        'Condition Info'
        , str
        , false, true
        , this.getGlobal('OK'), this.getGlobal('Close')
      ).subscribe(() => {
      });
    }
  }

  openPreviewTab(): void {
    const obj = {
      qcnfID: this.qcnfID,
      qverID: ExcCoreModule.Guid.NewGuid(),
      isTest: true,
      qcfgName: this.getRessource('TooltipPreview')
    };
    new ExgApplicationTab(this.getRessource('TooltipPreview'), QuestionnaireRendererComponent, obj, this.qcnfID, {}, true,
      'far fa-clipboard-list').Open();
  }

  /** Dropdown List Functions */
  //#region "DropDownlist"
  selectOption(option: any, disabled: boolean): void {
    if (disabled && option.kidID !== this.selectedQuest?.quest_kidID) {
    } else {
      this.selectedOption = option;
      if (this.selectedQuest) {
        this.selectedQuest.quest_kidID = option.kidID;
      }
      this.searchQuery = option.kidName;
      this.kids = this.kidList;
      this.isKidListVisible = false;
      this.kids.forEach(x => {
        x.selectable = this.questionnaire.findIndex(quest => quest.quest_kidID === x.kidID) !== -1;
      });
      this.isChange = true;
    }
  }

  deleteCurrentKidOption(): void {
    this.selectedOption = null;
    if (this.selectedQuest) {
      this.selectedQuest.quest_kidID = '';
    }
    this.searchQuery = '';
    this.kids.forEach(x => {
      x.selectable = this.questionnaire.findIndex(quest => quest.quest_kidID === x.kidID) !== -1;
    });
    this.isChange = true;
  }

  getConditionalElementList(item: Questionnaire): Questionnaire[] {
    return this.questionnaire.filter(x => x.questCondition === item.questID);
  }

  filterOptions(): void {
    this.kids = this.kidList.filter(option =>
      option.kidName.toLowerCase().includes(this.searchQuery.toLowerCase())
    );
    this.isKidListVisible = true;
  }

  toggleVisibility(): void {
    this.isKidListVisible = !this.isKidListVisible;
  }

  getID(value: any): string {
    const _self = this;
    let str = '';
    if (_self.selectedOption && _self.selectedOption.kidID === value) {
      str = 'selected-li';
      QuestionnaireEditorComponent.setScrollOnIcon();
    }
    return str;
  }

  //#endregion "DropDownlist"

  /** Generic Functions */
  setFocus(): void {
    if (this.selectedOption) {
      this.selectInput.nativeElement.focus();
    }
  }

  getFreeQuestionList(): void {
    // All moveable Editor Items apart from the options own parent element
    if (this.selectedQuest) {
      if (this.selectedQuest.quest_enmIdent_questType === 3) {
        this.freeQuestions = [];
        this.questionnaire.forEach((x) => {
          if ([1, -1, 2].includes(x.quest_enmIdent_questType) && this.selectedQuest?.questParentkey !== x.questKey) {
            x.valid = !((x.quest_enmIdent_questType === 1 && x.questKey.substring(0, 4) === this.selectedQuest?.questKey.substring(0, 4))
              || (x.quest_enmIdent_questType === -1 && x.questKey.substring(0, 9) === this.selectedQuest?.questKey.substring(0, 9))
              || (this.getParentConditional(x.questParentkey) || this.getParentOfParentConditional(x.questParentkey))
              || (x.questConditional && x.questCondition !== this.selectedQuest?.questID)
              || this.isLocked);
            this.freeQuestions.push(x);
          }
        });
      }
    }
  }

  getParentConditional(parentKey: any): boolean {
    if (parentKey) {
      return this.questionnaire.find(x => x.questKey === parentKey)?.questConditional as boolean;
    } else {
      return false;
    }
  }

  getParentOfParentConditional(parentKey: any): boolean {
    if (parentKey) {
      const topElement = this.questionnaire.find(x => x.questKey === parentKey);
      if (topElement) {
        return this.questionnaire.find(x => x.questKey === topElement.questParentkey)?.questConditional as boolean;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  setChangeMode(): void {
    this.isChange = true;
  }

  removeCondition(data: any): void {
    data.questCondition = null;
    data.questCondition_questID = null;
    data.questConditional = false;
    this.isChange = true;
  }

  changeFollowUpType(e: number, node: any): void {
    if (e === 1) {
      node.questFollowUpDays = null;
    } else {
      node.questFollowUpFixD = null;
    }
  }

  toggleSelectMode(): void {
    if (!this.isMultipleSelect) {
      this.selectedItems = [];
    }
    this.isMultipleSelect = !this.isMultipleSelect;
  }

  setMultipleSelect(node: any): void {
    if (this.selectedItems.findIndex(e => e.questID === node.questID) !== -1) {
      this.selectedItems = this.selectedItems.filter(x => x.questID !== node.questID);
    } else {
      this.selectedItems.push(node);
    }
  }

  /** Editor View Control Functions */
  toggleAccordion(): void {
    this.followupIsActive = !this.followupIsActive;
  }

  toggleConditionalAccordion(): void {
    this.conditionalIsActive = !this.conditionalIsActive;
  }

  toggleDetailAccordion(): void {
    this.detailsIsActive = !this.detailsIsActive;
  }

  toggleTableAccordion(): void {
    this.tableDetailsIsActive = !this.tableDetailsIsActive;
  }

  toggleChildren(node: any): void {
    const _self = this;
    if ([1, -1].includes(node.quest_enmIdent_questType)) {
      if (_self.collapsed === undefined) {
        _self.collapsed = [];
      }
      /* Collapse */
      if (_self.collapsed.indexOf(node.questID.toString()) === -1) {
        _self.collapsed?.push(node.questID.toString());
        _self.questionnaire.forEach((item) => {
          if (QuestionnaireEditorComponent.convertToPaddedString(this.getIdent(item.questID).toString()).search(
              QuestionnaireEditorComponent.convertToPaddedString(this.getIdent(node.questID).toString())) === 0 &&
            item.questIdentation !== node.questIdentation && this.hiddenItems.indexOf(item.questID.toString()) === -1) {
            _self.hiddenItems.push(item.questID.toString());
          }
        });
        /* Expand */
      } else {
        _self.collapsed = _self.collapsed.filter((item: any) => item !== node.questID);
        const children: any[] = this.getChildren(node);
        let collapesdChildren: any[] = [];
        children.forEach((item) => {
          if (this.collapsed.indexOf(item.questID) !== -1) {
            // collapesdChildren.push(item);
            collapesdChildren = collapesdChildren.concat(this.getChildren(item));
            this.hiddenItems = this.hiddenItems.filter((x: any) => x !== item.questID);
          } else {
            // children.splice(index, 1);
            this.hiddenItems = this.hiddenItems.filter((x: any) => x !== item.questID);
          }
        });
        if (collapesdChildren) {
          collapesdChildren.forEach(x => {
            this.hiddenItems.push(x.questID);
          });
        }
      }
    }
    // _self.questionnaire = _self.questionnaire.find(x => !_self.hidenItems.includes(x.questID) );
  }

  collapseAllChapter(): void {
    if (!this.isMultipleSelect) {
      this.questionnaire.forEach(item => {
        if ([1, -1].includes(item.quest_enmIdent_questType) && this.collapsed.indexOf(item.questID) === -1) {
          this.collapsed.push(item.questID);
          const children = this.getChildren(item);
          children.forEach(child => {
            this.hiddenItems.push(child.questID);
          });
        }
      });
    }
  }

  isChapterHeader(value: any): boolean {
    return [1, -1].includes(value.quest_enmIdent_questType as number);
  }

  isQuestionHeader(value: any): boolean {
    return [2].includes(value.quest_enmIdent_questType as number);
  }

  isUpload(value: any): boolean {
    return [4, 5].includes(value as number);
  }

  isInput(value: any): boolean {
    return [7, 9, 10, 11, 12, 13, 14].includes(value as number);
  }

  getChapter(index: any): string {
    for (let i = index - 1; i >= 0; i--) {
      if ([-1, 1].includes(this.questionnaire[i].quest_enmIdent_questType) &&
        (([-1, 1].includes(this.questionnaire[index].quest_enmIdent_questType)
            && this.questionnaire[i].questIdentation === this.questionnaire[index].questIdentation - 1)
          || [2, 3].includes(this.questionnaire[index].quest_enmIdent_questType))) {
        this.questionnaire[i].counter++;
        return `${(this.questionnaire[i].quest_Ident)}.${(this.questionnaire[i].counter)}`;
      }
      if ([1, 2, 3].includes(this.questionnaire[i].quest_enmIdent_questValueFormat) && this.questionnaire[i].quest_enmIdent_questType === 2
        && this.questionnaire[index].quest_enmIdent_questType === 3) {
        this.questionnaire[i].counter++;
        return `${(this.questionnaire[i].quest_Ident)}.${(this.questionnaire[i].counter)}`;
      }
    }
    return '';
  }

  getChapterNode(node: Questionnaire): Questionnaire {
    let val: Questionnaire;
    this.questionnaire.forEach((x) => {
      if (node.questParentkey.startsWith(x.questKey) && [1, -1].includes(x.quest_enmIdent_questType)) {
        val = x;
      }
    });
    // @ts-ignore
    return val;
  }

  isDisabledInConditionalList(row: Questionnaire): boolean {
    return (row.questConditional && row.questCondition !== this.selectedQuest?.questID) || this.isLocked ||
      (this.getChapterNode(row) && this.getChapterNode(row)?.questConditional);
  }

  getConditionalListTooltip(row: Questionnaire): string {
    if (row.questConditional && row.questCondition !== this.selectedQuest?.questID) {
      return 'this question is Conditional by other question';
    } else if (this.getChapterNode(row) && this.getChapterNode(row)?.questConditional) {
      return 'this question can not choose because all chapter is chosen';
    }
    return '';
  }

  getParentQuest(questParentKey: string): string {
    let val = '';
    this.questionnaire.forEach((x) => {
      if (questParentKey === x.questKey && x.quest_enmIdent_questType === 2) {
        val = x.questID;
      }
    });
    return val;
  }

  isDisabled(item: any, index: number): boolean {
    return ([1, 2, 3].includes(item.quest_enmIdent_questValueFormat) && this.questionnaire[index + 1] &&
      this.questionnaire[index + 1].quest_enmIdent_questType === 3);
  }

  isOptionDisabled(item: any): boolean {
    return ([1].includes(item.quest_enmIdent_questValueFormat) && item.quest_enmIdent_questType === 3);
  }

  insertArrayAtIndex<T extends Record<string, any>>(
    arr1: T[],
    arr2: T[],
    index: number
  ): T[] {
    return [...arr1.slice(0, index), ...arr2, ...arr1.slice(index)];
  }

  isQuestion(obj: any): boolean {
    return this.questionnaire[obj.previousIndex] !== undefined && this.questionnaire[obj.previousIndex].quest_enmIdent_questType === 2;
  }

  isChapter(obj: any): boolean {
    return this.questionnaire[obj.previousIndex] !== undefined && (this.questionnaire[obj.previousIndex].quest_enmIdent_questType === 1 ||
      this.questionnaire[obj.previousIndex].quest_enmIdent_questType === -1);
  }

  isBetweenOptions(currentIndex: number): boolean {
    // TODO: Check this
    return !(currentIndex === this.questionnaire.length) &&
      (this.questionnaire[currentIndex]?.quest_enmIdent_questType === 3 &&
        this.questionnaire[currentIndex + 1]?.quest_enmIdent_questType === 3);
  }

  isBetweenQuestionAndOption(currentIndex: number): boolean {
    return this.questionnaire[currentIndex]?.quest_enmIdent_questType === 2 &&
      [1, 2, 3].includes(this.questionnaire[currentIndex]?.quest_enmIdent_questType) &&
      this.questionnaire[currentIndex + 1]?.quest_enmIdent_questType === 3;
  }

  hasChild(obj: any): boolean {
    return (this.questionnaire.filter(item =>
      (item.questParentkey === obj.questKey || item.questKey.indexOf(obj.questKey) === 0) && item.questKey !== obj.questKey)).length > 0;
  }

  validateQuestID(array: any): any[] {
    array.forEach((item: any) => {
      const questID = ExcCoreModule.Guid.NewGuid();
      if (item.questCondition && item.quest_enmIdent_questType === 1 && array.finalIndex((x: any) => x.questID === item.questID) === -1) {
        item.questCondition = null;
        item.questConditional = false;
        item.questCondition_questID = null;
      }
      array.forEach((element: any) => {
        if (element.questCondition_questID === item.questID) {
          element.questCondition_questID = questID;
        }
        if (element.questCondition === item.questID) {
          element.questCondition = questID;
        }
      });
      /*  this.replaceValue(array, 'questCondition_questID', item.questID, questID);
        this.replaceValue(array, 'questCondition', item.questID, questID);*/
      item.questID = questID;
    });
    return array;
  }

  hasKPI(selectedQuest: any): boolean {
    return ([9, 10, 11, 12].includes(selectedQuest.quest_enmIdent_questValueFormat) &&
        selectedQuest.quest_enmIdent_questType === 2) ||
      selectedQuest.quest_enmIdent_questType === 1;
  }

  getChildren(node: Questionnaire): Questionnaire[] {
    const children: Questionnaire[] = [];
    this.questionnaire.forEach(child => {
      if ((child.questParentkey === node.questKey || child.questKey.indexOf(node.questKey) === 0) && child.questKey !== node.questKey) {
        children.push(child);
      }
    });
    return children;
  }

  getIcon(node: any): string {
    let icon = '';
    if (this.collapsed.indexOf(node.questID) === -1) {
      icon = 'fa-chevron-down';
    } else {
      icon = 'fa-chevron-right';
    }
    if (![1, -1].includes(node.quest_enmIdent_questType) || !this.hasChild(node)) {
      icon = '';
    }
    return icon;
  }

  getIdent(questID: any): number {
    return this.questionnaire.find(x => x.questID === questID)?.quest_Ident as number;
  }

  hasSeparator(i: any): boolean {
    return this.toolbox[i].quest_enmIdent_questType !== this.toolbox[i + 1]?.quest_enmIdent_questType && this.toolbox[i + 1] &&
      this.toolbox[i].quest_enmIdent_questType !== 1;
  }

  checkCopyPossibility(): boolean {
    const curIndex = this.questionnaireIndex;
    if (this.selectedToolbox) {
      let newQuestionnair: any[] = [];
      if (this.hiddenItems.length !== 0) {
        newQuestionnair = this.questionnaire.filter(x => !this.hiddenItems.includes(x.questID));
      } else {
        newQuestionnair = this.questionnaire;
      }
      switch (this.selectedToolbox.data?.quest_enmIdent_questType) {
        case 1: {
          // if chapter
          /* console.log(curIndex);*/
          if (curIndex === 0 || curIndex === this.questionnaire.length - 1) {
            //  console.log(curIndex);
            return true;
          } else {
            if (!this.isBetweenOptions(curIndex) && !this.isBetweenQuestionAndOption(curIndex)) {
              /* console.log(curIndex);*/
              return true;
            }
          }
          break;
        }
        case -1: {
          if ((curIndex !== 0 && curIndex !== newQuestionnair.length - 1) &&
            (!this.isBetweenOptions(curIndex) && !this.isBetweenQuestionAndOption(curIndex))) {
            // console.log(curIndex);
            return true;
          }
          break;
        }
        case 3: {
          if (this.isParentSelectOption(this.questionnaire[curIndex].quest_enmIdent_questValueFormat) &&
            this.isParentSelectOption(this.questionnaire[curIndex - 1].quest_enmIdent_questValueFormat)) {
            // console.log(curIndex);
            return true;
          }
          break;
        }
        case 2: {
          // if question
          if ((curIndex !== 0 && curIndex !== newQuestionnair.length - 1) &&
            (!this.isBetweenOptions(curIndex) && !this.isBetweenQuestionAndOption(curIndex))) {
            // console.log(curIndex);
            return true;
          }
          break;
        }
      }
    }
    /*console.log(curIndex);*/
    return false;
  }

  checkMovePossibility(curIndex: number): boolean {
    if (this.isMove) {
      if (this.selectedQuest) {
        let newQuestionnair: any[] = [];
        if (this.hiddenItems.length !== 0) {
          newQuestionnair = this.questionnaire.filter(x => !this.hiddenItems.includes(x.questID));
        } else {
          newQuestionnair = this.questionnaire;
        }
        switch (this.selectedQuest?.quest_enmIdent_questType) {
          case 1: {
            // if chapter
            if (curIndex === 0 || curIndex === this.questionnaire.length - 1) {
              return true;
            } else {
              if (!this.isBetweenOptions(curIndex) && !this.isBetweenQuestionAndOption(curIndex)) {
                return true;
              }
            }
            break;
          }
          case -1: {
            if ((curIndex !== 0 && curIndex !== newQuestionnair.length - 1) ||
              (!this.isBetweenOptions(curIndex) && !this.isBetweenQuestionAndOption(curIndex))) {
              return true;
            }
            break;
          }
          case 3: {
            if (this.isParentSelectOption(this.questionnaire[curIndex].quest_enmIdent_questValueFormat) &&
              this.isParentSelectOption(this.questionnaire[curIndex - 1].quest_enmIdent_questValueFormat)) {
              return true;
            }
            break;
          }
          case 2: {
            // if question
            if ((curIndex !== 0 && curIndex !== newQuestionnair.length - 1) ||
              (!this.isBetweenOptions(curIndex) && !this.isBetweenQuestionAndOption(curIndex))) {
              return true;
            }
            break;
          }
        }
      }
      // console.log(curIndex);
      return false;
    } else {
      return true;
    }
  }

  isDeleteAllowed(): boolean | undefined {
    return this.selectedQuest &&
      !(this.selectedQuest?.quest_enmIdent_questValueFormat === 1 && this.selectedQuest?.quest_enmIdent_questType === 3);
  }

  isValidUser(): boolean {
    return this.excSecurityService.isFeatured('QUESTCNFEDIT');
  }

  isItemInSelectedItems(node: any): boolean {
    return this.selectedItems.findIndex(e => e.questID === node.questID) !== -1;
  }

  isMultipleSelectAvailable(node: any): boolean {
    return node.quest_enmIdent_questType === 2;
  }

  hasConditions(item: Questionnaire): boolean {
    return this.questionnaire.findIndex(x => x.questCondition === item.questID) !== -1;
  }

  getArray(val: string): any {
    return JSON.parse(val);
  }

  /** Table Control (Type 17) Functions */
  selectRow(i: number): void {
    if (this.selectedQuest?.questConfiguration !== undefined) {
      this.selectedQuest.configs = JSON.parse(this.selectedQuest.questConfiguration);
      this.selectedColIndex = undefined;
      this.selectedRowIndex = i;
      if (this.selectedQuest.configs) {
        this.selectedRow = this.selectedQuest.configs[i];
      }
    }
  }

  selectCol(i: number): void {
    if (this.selectedQuest?.questConfiguration !== undefined) {
      this.selectedQuest.configs = JSON.parse(this.selectedQuest.questConfiguration);
      this.selectedRowIndex = undefined;
      this.selectedColIndex = i;
      if (this.selectedQuest.configs) {
        this.selectedCol = this.selectedQuest.configs[0].cols[i];
      }
    }
  }

  appendRow(index: number): void {
    if (this.selectedQuest && this.selectedQuest.configs) {
      const cols: TableCol[] = this.selectedQuest.configs[0].cols;
      cols.forEach(x => x.score = 0);
      const newRow: TableRow = {x: this.getResource('NewRow'), cols};
      this.selectedQuest.configs.splice(index, 0, newRow);
      this.selectedQuest.questConfiguration = JSON.stringify(this.selectedQuest.configs);
      if (index === this.selectedRowIndex) {
        this.selectedRowIndex = index + 1;
      }
      this.isChange = true;
    }
  }

  appendCol(index: number): void {
    if (this.selectedQuest && this.selectedQuest.configs) {
      for (const row of this.selectedQuest.configs) {
        row.cols.splice(index, 0, {y: this.getResource('NewCol'), score: 0});
      }
      this.selectedQuest.questConfiguration = JSON.stringify(this.selectedQuest.configs);
      if (index === this.selectedColIndex) {
        this.selectedColIndex = index + 1;
      }
      this.isChange = true;
    }
  }

  changeRowTitel(index: number, value: string): void {
    if (this.selectedQuest && this.selectedQuest.configs) {
      this.selectedQuest.configs[index].x = value;
      this.selectedQuest.questConfiguration = JSON.stringify(this.selectedQuest.configs);
      this.isChange = true;
    }
  }

  changeColTitel(index: number, value: string): void {
    if (this.selectedQuest && this.selectedQuest.configs) {
      for (const row of this.selectedQuest.configs) {
        if (row.cols[index]) {
          row.cols[index].y = value;
        }
      }
      this.selectedQuest.questConfiguration = JSON.stringify(this.selectedQuest.configs);
      this.isChange = true;
    }
  }

  selectCell(i: any, k: any): void {
    if (this.selectedQuest && this.selectedQuest.questConfiguration !== undefined) {
      this.selectedQuest.configs = JSON.parse(this.selectedQuest.questConfiguration);
      this.selectedRowIndex = i;
      this.selectedColIndex = k;
      if (this.selectedQuest.configs) {
        this.selectedScore = this.selectedQuest.configs[i].cols[k].score;
      }
      this.selectedQuest.questConfiguration = JSON.stringify(this.selectedQuest.configs);
    }
  }

  getClassName(i: number | undefined, j: number | undefined, type: string, questID: string | undefined): string {
    let className = '';
    if (i === this.selectedRowIndex && this.selectedColIndex === null && type === 'row' && questID === this.selectedQuest?.questID) {
      className = 'selected';
    }
    if (j === this.selectedColIndex && this.selectedRowIndex === null && type === 'col') {
      className = 'selected';
    }
    if (j === this.selectedColIndex && this.selectedRowIndex === i && type === 'cell' && questID === this.selectedQuest?.questID) {
      className = 'selected';
    }
    if (j === this.selectedColIndex && this.selectedRowIndex === null && type === 'cell' && questID === this.selectedQuest?.questID) {
      className = 'selected';
    }
    return className;
  }

  changeCellValue(i: number, j: number, val: number): void {
    if (this.selectedQuest && this.selectedQuest.configs) {
      this.selectedQuest.configs[i].cols[j].score = val;
      this.selectedQuest.questConfiguration = JSON.stringify(this.selectedQuest.configs);
      this.isChange = true;
    }
  }

  deleteRowAtIndex(index: number): void {
    if (this.selectedQuest && this.selectedQuest.configs) {
      if (index >= 0 && index < this.selectedQuest.configs.length) {
        this.selectedQuest.configs.splice(index, 1);
      }
      this.selectedQuest.questConfiguration = JSON.stringify(this.selectedQuest.configs);
      this.isChange = true;
    }
  }

  deleteColsAtIndex(index: number): void {
    if (this.selectedQuest && this.selectedQuest.configs) {
      for (const row of this.selectedQuest.configs) {
        if (index >= 0 && index < row.cols.length) {
          row.cols.splice(index, 1);
        }
      }
      this.selectedQuest.questConfiguration = JSON.stringify(this.selectedQuest.configs);
      this.isChange = true;
    }
  }

  /** Segment Functions */
  getSegmentIndex(segID: any): number {
    if (this.segments?.length > 0) {
      return this.segments.findIndex(x => x.segID === segID);
    } else {
      return -1;
    }
  }

  setSegment(obj: Questionnaire, index: number): void {
    obj.quest_segID = this.segments[index].segID;
    this.isChange = true;
  }

  deleteSegmentLink(obj: Questionnaire): void {
    obj.quest_segID = null;
    this.isChange = true;
  }

  /** Additional Pre Header Information Functions */
  fileUpload(fileData: any, questData: any): void {
    const _self = this;
    const formData = new FormData();
    fileData.forEach((fileItem: any) => formData.append('file[]', fileItem.asBlob, fileItem.fullName));
    const url = _self.excRestServiceCore.computeUrl('QuestionnaireAttachmentC', {
      FKID: questData.questID,
      qcnfID: this.qcnfID
    });
    _self.excRestServiceCore.post(url,
      formData, {}).subscribe((response: any) => {
      if (_self.selectedQuest && response.data[0]) {
        _self.selectedQuest.FileStream = response.data[0].FileStream;
        _self.selectedQuest.MIME = response.data[0].MIME;
      }
    });
  }

  fileDelete(): void {
    const _self = this;
    if (_self.selectedQuest) {
      const url = this.excRestServiceCore.computeUrl('QuestionnaireAttachmentD', {FKID: _self.selectedQuest.questID});
      this.excRestServiceCore.delete(url, {FKID: _self.selectedQuest.questID}, {}).subscribe((response: any) => {
        if (_self.selectedQuest && response.success) {
          _self.selectedQuest.FileStream = '';
          _self.selectedQuest.MIME = '';
        }
      });
    }
  }

  toggleZoom(e: any): void {
    if (this.imageContainer) {
      this.imageContainer.openAboveCenter(e);
    }
  }

  /** Custom Tooltip implementation */
  toggleTooltip(e: any, str: string, type: string): void {
    if (this.toolTipContainer) {
      if (type === 'open') {
        this.selectedTooltip = str;
        this.toolTipContainer.openAboveCenter(e);
      } else {
        this.toolTipContainer.close();
      }
    }
  }

  /** Custom HTML (18) and Object List (19) Input Type Functions */
  pasteClipboardElement(element: any): void {
    navigator.clipboard.readText().then((data) => {
      if (element.quest_enmIdent_questValueFormat === 18) {
        element.questConfiguration = data;
        this.isChange = true;
      } else if (element.quest_enmIdent_questValueFormat === 19) {
        let validData;
        try {
          validData = JSON.parse(data);
        } catch (e) {
          return this.modalService.showToast(
            this.getRessource('ObjectFormatWarning'), 'md-toast', 'fa fas fa-exclamation');
        }
        if (this.isObjectList(JSON.parse(data))) {
          const key = 'ObjectList' + element.questKey + 'CmpID' + this.ComponentUID;
          // @ts-ignore
          this.rerender[key] = true;
          element.questConfiguration = JSON.parse(JSON.stringify(data));
          this.isChange = true;
          setTimeout((e: any) => {
            // @ts-ignore
            this.rerender[key] = false;
          }, 5);
        } else {
          this.modalService.showToast(
            this.getRessource('ObjectFormatWarning'), 'md-toast', 'fa fas fa-exclamation');
        }
      }
    });
  }

  copyClipboardElement(element: any): string {
    if (element.quest_enmIdent_questValueFormat === 18) {
      return element.questConfiguration;
    } else if (element.quest_enmIdent_questValueFormat === 19) {
      let rtrnString: string;
      rtrnString = JSON.stringify(element.questConfiguration);
      rtrnString = rtrnString.replace('/r/n', '').replace(' ', '')
        .replace(/\\"/g, '"').replace('\\\r\\\n', '');
      rtrnString = rtrnString.substring(1, rtrnString.length - 1);
      return rtrnString;
    } else {
      return '';
    }
  }

  getClipboardHeader(questType: number): string {
    if (questType === 18) {
      return this.getResource('QuestionHMTLCaption');
    } else if (questType === 19) {
      return this.getResource('QuestionObjectListCaption');
    } else {
      return 'Label';
    }
  }

  getStringifiedElement(element: any): string {
    return JSON.stringify(element);
  }

  getJSONObject(element: any): any {
    if (element) {
      return JSON.parse(element);
    }
  }

  isObjectList(object: any): object is ObjectList {
    return object?.Headers && object?.Types && object?.Template && object?.Required && object?.MinRow && object?.MaxRow;
  }

  private showCheckToast(message: string): void {
    this.modalService.showToast(
      message, 'md-toast', 'fa fas fa-check');
  }

  /** Return Value Functions */
  isParentSelectOption(value: number): boolean {
    return [-1, 2, 3].includes(value);
  }

  isParentYesOrNO(value: number): boolean {
    return [1].includes(value);
  }

  isSelected(index: any): boolean {
    return this.freeQuestions[index].questCondition === this.selectedQuest?.questID;
  }

  transformIsLockedForDisable(value: boolean): string {
    return value.toString();
  }

  /** Chapter & Subchapter duplicate */
  duplicateSelectedChapter(): void {
    if (this.selectedQuest && [1, -1].includes(this.selectedQuest.quest_enmIdent_questType)) {
      let headerResource: string;
      if (this.selectedQuest?.quest_enmIdent_questType === 1) {
        headerResource = this.getRessource('DuplicateChapterHeader', {ident: this.selectedQuest?.quest_Ident});
      } else {
        headerResource = this.getRessource('DuplicateSubChapterHeader', {ident: this.selectedQuest?.quest_Ident});
      }
      this.modalService.showSimple(
        headerResource, this.getRessource('DuplicateMessage')
        , true, true
        , this.getRessource('DuplicateSubmit'), this.getGlobal('Cancel')
      ).subscribe(ret => {
        if (ret && this.selectedQuest) {
          const index = this.questionnaire.indexOf(this.selectedQuest);
          let objLength = 0;
          let newChapter: Questionnaire[];
          newChapter = [];
          this.questionnaire.forEach((x) => {
            if (this.selectedQuest && x.questKey.startsWith(this.selectedQuest.questKey)) {
              const newQuestObj = {
                quest_enmIdent_questType: x.quest_enmIdent_questType,
                quest_Ident: x.quest_Ident,
                questIdentation: x.questIdentation,
                quest_enmIdent_questValueFormat: x.quest_enmIdent_questValueFormat,
                name: x.name,
                questText: x.questText,
                questHelp: x.questHelp,
                questScore: x.questScore,
                questIsOptional: x.questIsOptional,
                questFollowUp: x.questFollowUp,
                questFollowUpDays: x.questFollowUpDays,
                questFollowUpFixD: x.questFollowUpFixD,
                quest_kidID: null,
                quest_segID: null,
                questFollowUpShortText: x.questFollowUpShortText,
                questCondition: null,
                questCondition_questID: null,
                questConditional: null,
                questID: ExcCoreModule.Guid.NewGuid(),
                icon: x.icon,
                tooltip: x.tooltip,
                questIsKO: x.questIsKO,
                questIsInapplicable: x.questIsInapplicable,
                questPreText: x.questPreText,
                questLink: x.questLink,
                questLinkText: x.questLinkText,
                questHexCode: x.questHexCode,
                questConfiguration: x.questConfiguration
              };
              ExcCoreModule.Array.Add(newChapter, newQuestObj);
              objLength++;
            }
          });
          const questionnaireObject = this.validateQuestID(newChapter);
          this.questionnaire.splice(index + objLength, 0, ...questionnaireObject);
          this.setIdentation(this.questionnaire);
          this.isChange = true;
        }
      });
    }
  }

  changeQuestionnaire(value: any): void {
    this.Data.qcnfID = value.qcnfID;
    this.ngOnInit();
  }

  openModalOeQuestionnaireComponent(config?: any): void {
    this.modalService.show('ModalOeQuestionnaireComponent', config)
      .subscribe((rtVal: any) => {
        if (rtVal) {
          if (rtVal?.del) {
            /* this.excRestServiceCore
               .delete(
                 this.excRestServiceCore.computeUrl('OEQuestionnaireCUD', {
                   oeID: '00000000-0000-0000-0000-000000000000'
                 }), {
                   qcnfID: rtVal.qcnfID,
                   qcfgUPT: rtVal.qcfgUPT
                 }
               )
               .subscribe((ret: any) => {
                 if (ret.success) {
                   this.modalService
                     .showToast('Bericht gelöscht'
                       , 'md-toast bg-green'
                       , 'far fa-check');
                 }
               });*/
          } else {
            const dataObject = {
              qcfgName: rtVal.qcfgName
            };

            if (rtVal && rtVal.qcnfID) {
              Object.assign(
                dataObject, {
                  qcnfID: rtVal.qcnfID,
                  qcfgUPT: rtVal.qcfgUPT
                });
            }

            this.excRestServiceCore
              .post(this.excRestServiceCore.computeUrl('OEQuestionnaireCUD', {
                oeID: this.currentConfig.qcfg_oeID
              }), dataObject)
              .subscribe((ret: any) => {
                if (ret.success) {
                  if (rtVal.qcnfID) {
                    this.modalService
                      .showToast('Bericht geupdated',
                        'md-toast bg-green',
                        'far fa-check');
                  } else {
                    this.modalService
                      .showToast('Bericht erstellt',
                        'md-toast bg-green',
                        'far fa-check');
                  }
                  this.Data.qcnfID = ret.data[0].qcnfID;
                  this.ngOnInit();
                }
              });
          }
        }
      });
  }
}
